var _circle, _circle2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 75,
    cy: 75,
    r: 75,
    fill: "#C5A262"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 75,
    cy: 75,
    r: 60,
    fill: "#C5A262"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.9669 60.0308C95.6764 59.7379 95.3308 59.5054 94.95 59.3468C94.5692 59.1881 94.1607 59.1064 93.7482 59.1064C93.3357 59.1064 92.9272 59.1881 92.5464 59.3468C92.1656 59.5054 91.82 59.7379 91.5294 60.0308L68.2482 83.3433L58.4669 73.5308C58.1653 73.2394 57.8092 73.0103 57.4191 72.8566C57.0289 72.7028 56.6123 72.6274 56.193 72.6347C55.7736 72.6419 55.3599 72.7317 54.9752 72.8989C54.5906 73.066 54.2427 73.3073 53.9513 73.6089C53.6599 73.9106 53.4308 74.2666 53.2771 74.6568C53.1233 75.047 53.0479 75.4636 53.0552 75.8829C53.0624 76.3022 53.1522 76.716 53.3194 77.1006C53.4865 77.4853 53.7278 77.8332 54.0294 78.1246L66.0294 90.1246C66.32 90.4175 66.6656 90.6499 67.0464 90.8086C67.4272 90.9673 67.8357 91.0489 68.2482 91.0489C68.6607 91.0489 69.0692 90.9673 69.45 90.8086C69.8308 90.6499 70.1764 90.4175 70.4669 90.1246L95.9669 64.6246C96.2841 64.3319 96.5373 63.9768 96.7104 63.5815C96.8836 63.1861 96.973 62.7593 96.973 62.3277C96.973 61.8961 96.8836 61.4692 96.7104 61.0739C96.5373 60.6786 96.2841 60.3234 95.9669 60.0308Z",
    fill: "#C5A262"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOutline);
export default __webpack_public_path__ + "static/media/check-outline.fefbad4f82297caf8c6d4ad92790fd75.svg";
export { ForwardRef as ReactComponent };